import NamedStorage from "./NamedStorage";

export type MobileOverride = "auto" | "mobile" | "pc";

export default class SettingsStorage {
  private mStorage: NamedStorage;

  constructor() {
    this.mStorage = new NamedStorage("Settings");
  }

  public GetDebugMode(): boolean {
    const val = this.mStorage.Get("debugMode");
    return val === "true";
  }

  public SetDebugMode(val: boolean): void {
    this.mStorage.Store("debugMode", val.toString());
  }

  public GetMobileOverride(): MobileOverride {
    const val = this.mStorage.Get("mobileOverride");
    if (val === "mobile" || val === "pc") return val;
    return "auto";
  }

  public SetMobileOverride(val: MobileOverride): void {
    this.mStorage.Store("mobileOverride", val);
  }
}
